export default {
  init() {
    // JavaScript to be fired on the singleAutobedrijfVoertuig page

      /**
       * Handle links to one of the tabs and set focus on tab, and scrollto tab
       */
      $('[href^="#tab-"]').click(function(e){

          e.preventDefault();

          var href = $(this).attr('href');

          $(href).focus();

          $.scrollTo(href, 200, {
              offset: {
                  top: -120,
              },
          });

      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleAutobedrijfVoertuig.js